import FeedbackBlock from '../FeedbackBlock';
import GlorySvg from '~/assets/glory.svg';
import ButtonRainbow, {
    MultipleCta,
} from '~/components/LandingPage/components/ButtonRainbow';

const Demonstration = ({ videoDefinition }) => {
    return (
        <div
            style={{
                position: 'relative',
                paddingTop: videoDefinition.paddingTop || '100%',
            }}>
            <iframe
                title={`${videoDefinition.label} - AI Perfect Assistant`}
                src={`https://customer-b5iz2r6cpeptxyuk.cloudflarestream.com/${videoDefinition.videoId}/iframe?muted=true&preload=true&loop=true&autoplay=true&poster=https%3A%2F%2Fcustomer-b5iz2r6cpeptxyuk.cloudflarestream.com%2F${videoDefinition.videoId}%2Fthumbnails%2Fthumbnail.jpg%3Ftime%3D%26height%3D600&controls=true`}
                loading='lazy'
                style={{
                    border: 'none',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    height: '100%',
                    width: '100%',
                }}
                className='rounded-2xl'
                allow='accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;'
                allowFullScreen
            />
        </div>
    );
};

export function SignUpForm() {
    return <MultipleCta />;
}

const HeroSection = ({
    title,
    subTitle,
    heroImageUrl,
    heroVideo,
    placement,
}) => {
    return (
        <section className='relative py-12 sm:py-16 lg:pb-40'>
            <div className='absolute bottom-0 right-0 overflow-hidden'>
                <img
                    className='w-full h-auto origin-bottom-right transform scale-150 lg:w-auto lg:mx-auto lg:object-cover lg:scale-75'
                    src='https://cdn.rareblocks.xyz/collection/clarity/images/hero/1/background-pattern.png'
                    alt=''
                />
            </div>

            <div className='relative px-4 mx-auto max-w-7xl sm:px-6 lg:px-8'>
                <div className='grid grid-cols-1 gap-y-4 lg:items-start lg:grid-cols-2 xl:grid-cols-2'>
                    <div className='text-center xl:col-span-1 lg:text-left md:px-16 lg:px-12 xl:pr-20'>
                        <div className='w-full flex items-center justify-center lg:justify-start pb-4'>
                            <img
                                src={GlorySvg}
                                className='w-64'
                                alt='#1 AI app for Office365'
                            />
                        </div>
                        <h1 className='text-4xl font-bold leading-tight text-gray-900 sm:text-5xl sm:leading-tight lg:text-6xl lg:leading-tight font-pj'>
                            {title}
                        </h1>
                        <p className='mt-2 text-lg text-gray-600 sm:mt-6 font-inter'>
                            {subTitle}
                        </p>
                        <div className='mt-8 sm:flex sm:items-center sm:justify-center lg:justify-start sm:space-x-5 items-center'>
                            <SignUpForm placement={placement} />
                        </div>
                        <div className='mt-8 sm:mt-16'>
                            <FeedbackBlock
                                authorName='Fernando Rodriguez'
                                authorRole='E-commerce Director at Wayfair'
                                title='A total game-changer!'
                                text={`This AI Assistant is a total game-changer for working on writing projects. It's a real time-saver, helping you to write better and fixing grammar mistakes, so the whole process is much easier and faster.`}
                            />
                        </div>
                    </div>

                    <div className='xl:col-span-1 rounded-full'>
                        {heroVideo ? (
                            <Demonstration videoDefinition={heroVideo} />
                        ) : (
                            <img
                                className='w-full mx-auto'
                                src={heroImageUrl}
                                alt={title}
                            />
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default HeroSection;
